import React from 'react';
import { motion } from 'framer-motion';
export function WhatYouWant() {
  return <section className="w-full bg-[#faf6ef] py-20 px-6 text-[#1e2a4a] text-center" data-id="element-218">
      <div className="max-w-[680px] mx-auto" data-id="element-219">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-220">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-8 text-[#1e2a4a]" data-id="element-221">
            What You Actually Want
          </h2>

          <div className="space-y-2 text-xl md:text-2xl leading-relaxed text-[#1e2a4a]/80 mb-12 font-light" data-id="element-222">
            <p data-id="element-223">Not a stricter house.</p>
            <p data-id="element-224">Not a softer house.</p>
            <p data-id="element-225">Not a new personality at night.</p>
          </div>

          <p className="text-xl md:text-2xl font-serif font-medium mb-8 text-[#1e2a4a]" data-id="element-226">
            You want bedtime to be:
          </p>

          <ul className="space-y-4 mb-12 inline-block text-left" data-id="element-227">
            {['boring', 'predictable', 'repeatable', 'done'].map((item, index) => <li key={index} className="flex items-center text-2xl md:text-3xl font-serif font-bold text-[#c9a96e]" data-id="element-228">
                  <span className="mr-4 text-xl" data-id="element-229">✦</span>
                  <span className="text-[#1e2a4a]" data-id="element-230">{item}</span>
                </li>)}
          </ul>

          <p className="text-xl md:text-2xl font-serif italic text-[#1e2a4a] border-t border-[#c9a96e]/30 pt-8 max-w-md mx-auto" data-id="element-231">
            Because when bedtime is boring, kids stop investing in it.
          </p>
        </motion.div>
      </div>
    </section>;
}